
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/9-things-you-didnt-know-you-could-do-in-the-uk",
      function () {
        return require("private-next-pages/blog/9-things-you-didnt-know-you-could-do-in-the-uk.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/9-things-you-didnt-know-you-could-do-in-the-uk"])
      });
    }
  